import { render, staticRenderFns } from "./SteperDownload.vue?vue&type=template&id=50ff6bfa&"
import script from "./SteperDownload.vue?vue&type=script&lang=js&"
export * from "./SteperDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports